import React, { memo, useCallback, useEffect, useState } from 'react'
import { FilterInput } from 'src/components/FilterInput'
import { useFilter } from 'src/components/CustomTable/hooks/useFilter'

export interface ISeachFilterData {
  filterValue: string
  filteredList: any[]
  filterPlaceholder?: string
}

interface ISearchFilter {
  filterPlaceholder?: string
  listToFilter: any[]
  getFilteredData: (filteredData: any) => void
  handleInitialPage: () => void
  propertiesToFilter: string[]
  isRemoteSearch?: boolean
  onSearchChange?: (value: string) => void
  searchValue?: string
}

const SearchFilterComponent: React.FC<ISearchFilter> = ({
  getFilteredData,
  handleInitialPage,
  listToFilter,
  propertiesToFilter,
  filterPlaceholder,
  isRemoteSearch = false,
  onSearchChange,
  searchValue = ''
}) => {
  const [filterValue, setFilterValue] = useState<string>(searchValue)
  const {
    filteredData,
    handleFilter,
    clearFilter
  } = useFilter({
    items: listToFilter,
    filterValue: filterValue,
    propertiesToFilter: propertiesToFilter && propertiesToFilter
  })

  const clearFilters = useCallback(() => {
    setFilterValue('')
    if (isRemoteSearch && onSearchChange) {
      onSearchChange('')
    } else {
      clearFilter()
    }
    handleInitialPage()
  }, [clearFilter, handleInitialPage, isRemoteSearch, onSearchChange])

  const handleApplyFilters = useCallback(() => {
    if (isRemoteSearch && onSearchChange) {
      onSearchChange(filterValue)
    } else {
      setTimeout(() => {
        handleFilter()
      }, 100)
    }
  }, [filterValue, isRemoteSearch, onSearchChange, handleFilter])

  useEffect(() => {
    if (isRemoteSearch) {
      // Para busca remota, não filtra localmente
      const seachFilterData: ISeachFilterData = {
        filterValue,
        filteredList: listToFilter
      }
      getFilteredData(seachFilterData)
    } else {
      // Para busca local, usa o filtro normal
      const seachFilterData: ISeachFilterData = {
        filterValue,
        filteredList: filteredData
      }
      getFilteredData(seachFilterData)
    }
  }, [filteredData, filterValue, isRemoteSearch, listToFilter, getFilteredData])

  // Sincroniza o valor interno com o valor externo quando mudar
  useEffect(() => {
    setFilterValue(searchValue)
  }, [searchValue])

  return (
    <FilterInput
      filterValue={filterValue}
      onFilterChange={(value: string) => setFilterValue(value)}
      onApplyFilters={handleApplyFilters}
      onClearFilters={clearFilters}
      placeholder={filterPlaceholder && filterPlaceholder}
    />
  )
}


export const SearchFilter = memo(SearchFilterComponent)
